import { useQueryClient } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';
import { URL_TARGETING_CONDITIONS } from 'definitions';
import { useExperiment } from './useExperiment';

export const useUrlTargeting = (experimentId: number) => {
  const { experiment } = useExperiment(experimentId);
  const queryClient = useQueryClient();
  const apiClient = useClient();

  type UrlTargeting = {
    id: number;
    url: string;
    condition: any;
  };
  const addUrlTargeting = async ({ url, condition }: Omit<UrlTargeting, 'id'>) => {
    const payload = { url, condition, experimentId };
    await apiClient.post(`/url-targeting`, payload);
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT'] });
  };

  const editUrlTargeting = async ({ id, url, condition }: UrlTargeting) => {
    const payload = { url, condition };
    await apiClient.put(`/url-targeting/${id}?experimentId=${experimentId}`, payload);
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT'] });
  };

  const deleteUrlTargeting = async (id: number) => {
    await apiClient.delete(`/url-targeting/${id}?experimentId=${experimentId}`);
    queryClient.invalidateQueries({ queryKey: ['EXPERIMENT'] });
  };

  return {
    URL_TARGETING_CONDITIONS,
    urlTargeting: experiment?.urlTargeting,
    addUrlTargeting,
    editUrlTargeting,
    deleteUrlTargeting,
  };
};
